import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ArrowLeft, User } from "lucide-react";
import { Button } from "./ui/button";
import FeedbackButton from "./FeedbackButton";

/**
 * Layout per operatori - NO sidebar, solo header con back button
 * Usato quando un operatore entra in una sezione specifica
 */
const OperatoreLayout = ({ children, title }) => {
  const navigate = useNavigate();
  const { user, localeCorrente } = useAuth();

  const handleBack = () => {
    navigate("/operatore");
  };

  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="operatore-layout">
      {/* Header con back button */}
      <header className="bg-card border-b border-border px-4 py-3 sticky top-0 z-50 shadow-sm">
        <div className="flex items-center gap-3 max-w-4xl mx-auto">
          <Button
            variant="ghost"
            size="icon"
            onClick={handleBack}
            className="text-foreground hover:bg-muted flex-shrink-0"
            data-testid="back-to-dashboard-btn"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          
          <div className="flex-1 min-w-0">
            <h1 className="text-foreground font-bold truncate">{title || "Sezione"}</h1>
            {localeCorrente && (
              <p className="text-muted-foreground text-xs truncate">{localeCorrente.nome}</p>
            )}
          </div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <div className="w-8 h-8 bg-primary/15 rounded-full flex items-center justify-center">
              <User className="h-4 w-4 text-primary" />
            </div>
            <span className="text-muted-foreground text-sm hidden sm:block">{user?.nome || user?.email || user?.telefono}</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 p-4 max-w-4xl mx-auto w-full">
        {children}
      </main>

      <FeedbackButton />
    </div>
  );
};

export default OperatoreLayout;
